module.exports = __webpack_public_path__ + "assets/media/evening.57b65370.mp3";